module.exports = __webpack_public_path__ + "6fbe1c263ee05872200eaa397c2fc3b5.svg";